import pptxgen from 'pptxgenjs'

import { percentageToInches, getCoordinates, SLIDE_SIZE_PX, decodeHtml } from '../helpers'
import { COLORS, OPEN_SANS_REGULAR } from '../common/constants'

const pptx = new pptxgen()

function renderPieChart({ x, y, height, width, parent, svgNode, slide }) {
  const coordinates = getCoordinates({ x, y }, parent)

  const xOffset = (width / 100) * 2
  const yOffset = (height / 100) * 2
  const translateX = percentageToInches(xOffset / 1920, 'x')
  const translateY = percentageToInches(yOffset / 1080, 'y')

  const chartPosition = {
    x: coordinates.x + translateX,
    y: coordinates.y + (height > 300 && translateY),
    h: percentageToInches((height - yOffset) / SLIDE_SIZE_PX.y, 'y'),
    w: percentageToInches((width - xOffset) / SLIDE_SIZE_PX.x, 'x'),
  }

  const data = svgNode.properties['data-json']
  const decodedData = JSON.parse(decodeHtml(data))
  const dataChartPieStat = decodedData.reduce(
    (acc, cur) => ({
      labels: [...acc.labels, cur.key],
      values: [...acc.values, cur.value],
    }),
    {
      labels: [],
      values: [],
    }
  )

  const exportOptionsRaw = svgNode.properties['data-export-options']
  const exportOptions = exportOptionsRaw ? JSON.parse(decodeHtml(exportOptionsRaw)) : {}

  const optsChartPie = {
    ...chartPosition,
    chartColors: COLORS,
    dataLabelColor: 'EEEEEE',
    dataLabelFontSize: 8,
    dataLabelFormatCode: '0%;;;',
    legendFontFace: OPEN_SANS_REGULAR,
    legendPos: 'b', // b | tr | l | r | t

    layout: {
      x: 0,
      y: 0,
      w: 1,
      h: 0.8,
    },

    showLegend: true,
    showLabel: false,
    showValue: false,
    showPercent: true,
    showLeaderLines: true,

    holeSize: 50, // %

    title: '',
    showTitle: false,

    ...exportOptions,
  }

  slide.addChart(pptx.ChartType.doughnut, [dataChartPieStat], optsChartPie)
}

export default renderPieChart
